import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function addCurrentCaseNumber(state = initialState.transactionSearch, action) {
  switch (action.type) {
    case types.ADD_CASE_NUMBER:
      return Object.assign({}, state, {
        addCurrentCaseNumber: action.addCurrentCaseNumber,
      });
    default:
      return state;
  }
}
